const path = require('path')
const prodEnv = process.argv[2] || 'TEST'
console.log('环境222--', prodEnv)
module.exports = {
    publicPath: './',
    // outputDir: 'wcba-3v3-analysis',//女子3v3
    // outputDir: 'wcba-report', //中国女篮名单解析
    // outputDir: 'wcba-nigeria-report',//尼日利亚女篮名单解析
    // outputDir: 'wcba-u23-report', //WCBA三人U23篮名单解析
    outputDir: 'talent-pool',
    //正式：talent-pool  测试：basketbal-talent-pool-preview
    // outputDir: prodEnv == 'prod' ? 'talent-pool' : 'basketbal-talent-pool-preview', //新人才库
    css: {
        loaderOptions: {
            less: {
                lessOptions: {
                    modifyVars: {
                        hack: `true; @import (reference) "${path.resolve('src/styles/index.less')}";`,
                        'btn-height-lg': '25px',
                        'table-padding-vertical': '20px',
                        'table-padding-horizontal': '12px',
                    },
                    javascriptEnabled: true,
                },
            },
        },
    },
}
